import { HStack, BoxProps, useColorMode } from '@chakra-ui/react';
import React from 'react';
import { getColorThemeSelector } from '../../../utils/funcs';

type props = {} & BoxProps;

export const CardTagContainer: React.FC<props> = (props) => {
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const { children, ...rest } = props;

    return (
        <HStack px="0px" mt="-12px !important" {...rest}>
            {children}
        </HStack>
    );
};

export default CardTagContainer;
